/**
 * 批量事务处理V4.0 API
 * 基于客户端状态追踪模式的统一批量处理
 */

import axios from './axios';

const BASE_URL = '/v1/batch-transaction-v4';

export const batchTransactionV4Api = {
  /**
   * 初始化批量事务数据
   * @param {string} flightIds - 逗号分隔的航班ID列表
   * @param {string} transactionType - 事务类型
   * @returns {Promise} 响应data
   */
  initializeData: async (flightIds, transactionType) => {
    const response = await axios.get(`${BASE_URL}/initialize-data`, {
      params: {
        flight_ids: flightIds,
        transaction_type: transactionType,
      },
    });
    return response.data;
  },

  /**
   * 初始化批量事务数据（支持供应商筛选）
   * @param {Object} params - 参数对象
   * @param {string} params.flight_ids - 逗号分隔的航班ID列表
   * @param {string} params.transaction_type - 事务类型
   * @param {number} [params.supplier_id] - 可选的供应商ID
   * @returns {Promise} 响应data
   */
  initializeDataWithSupplier: async (params) => {
    const response = await axios.get(`${BASE_URL}/initialize-data`, {
      params: params,
    });
    return response.data;
  },

  /**
   * 批量处理事务
   * @param {Object} payload - 批量处理请求数据
   * @returns {Promise} 响应data
   */
  batchProcess: async (payload) => {
    const response = await axios.post(`${BASE_URL}/batch-process`, payload);
    return response.data;
  },
};

export default batchTransactionV4Api;
